<template>
  <div class="home-content">
    <div class="carousel-content content-width">
      <v-carousel class="carousel-height" cycle show-arrows="hover" hide-delimiter-background>
        <v-carousel-item :alt="item.alt" cover v-for="(item,i) in items" :key="i" :src="item.src"></v-carousel-item>
      </v-carousel>
      <v-sheet class="left-content-mobile pa-5 justify-center" rounded elevation="3">
        <span class="welcome">{{ $t('teretulemast') }}</span>
        <p class="font-italic py-5">{{ $t('quote') }}</p>
        <p>{{ $t('home_desc') }}</p>
        <book-request></book-request>
      </v-sheet>
    </div>
    <div class="mt-15">
      <div class="py-10 content-selection">
        <div class="content-width">
          <div class="feedback-header pb-5">
            <div class="pr-3">
              <svg class="feedback-icon" opacity="80%" fill="#3b71f7" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-4.87 -4.87 58.44 58.44" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="47.784,13.309 24.349,0 0.914,13.309 24.349,26.698 "></polygon> <polygon points="24.349,29.002 8.548,19.974 0.914,24.309 24.349,37.698 47.784,24.309 40.151,19.974 "></polygon> <polygon points="24.349,40.002 8.548,30.974 0.914,35.309 24.349,48.698 47.784,35.309 40.151,30.974 "></polygon> </g> </g></svg>
            </div>
            <h2>{{ $t('voimalused') }}</h2>
          </div>
          <v-sheet class="text-content" rounded elevation="3">
            <v-card flat hover draggable="false" class="w-100 py-7" to="/tooted">
              <svg width="200px" height="200px" viewBox="-2.4 -2.4 28.80 28.80" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000000" stroke-width="0"><g id="SVGRepo_bgCarrier" stroke-width="0"><path transform="translate(-2.4, -2.4), scale(0.8999999999999999)" d="M16,27.41880604205653C18.540720326951845,27.816522541970862,21.32300974756361,29.033831549146967,23.551454171885304,27.75029205158565C25.780967583946673,26.466136838428596,26.171767614129323,23.465429998310537,27.05761209616124,21.049842239670095C27.87811645709802,18.812428867016077,28.647901139647253,16.579515469229626,28.52069281037923,14.199796148088549C28.385063815081757,11.662549236085574,27.792356368043407,9.129963446592626,26.310115764755526,7.066233834749346C24.74772225284161,4.890907002697685,22.520488140061797,3.2772901307834776,20.00851400078372,2.3482550206219877C17.381414908356632,1.3766417955592554,14.304460163651804,0.44347870187214067,11.801205902090306,1.7002205220254414C9.320375511436378,2.9457045899112266,9.351096112282033,6.566234728055839,7.495149271606918,8.63050489330493C5.584458162771753,10.75566417294271,1.3332374850493425,11.004205364991831,0.8968946658786976,13.828501281033656C0.4619765458866469,16.643575612818996,3.9029195471962264,18.468992113661706,5.624539484624869,20.738314051074354C6.946598760472786,22.480962385945833,7.989892581402682,24.41805566999975,9.829024468422155,25.602225358023404C11.669170009093405,26.787047711544872,13.837738418133082,27.08033230328377,16,27.41880604205653" opacity="80%" fill="#3b71f7"></path></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z" stroke="#000000" stroke-width="1"></path> <path d="M16.5 18.0001C17.3284 18.0001 18 18.6716 18 19.5001C18 20.3285 17.3284 21.0001 16.5 21.0001C15.6716 21.0001 15 20.3285 15 19.5001C15 18.6716 15.6716 18.0001 16.5 18.0001Z" stroke="#000000" stroke-width="1"></path> <path d="M2 3L2.26121 3.09184C3.5628 3.54945 4.2136 3.77826 4.58584 4.32298C4.95808 4.86771 4.95808 5.59126 4.95808 7.03836V9.76C4.95808 12.7016 5.02132 13.6723 5.88772 14.5862C6.75412 15.5 8.14857 15.5 10.9375 15.5H12M16.2404 15.5C17.8014 15.5 18.5819 15.5 19.1336 15.0504C19.6853 14.6008 19.8429 13.8364 20.158 12.3075L20.6578 9.88275C21.0049 8.14369 21.1784 7.27417 20.7345 6.69708C20.2906 6.12 18.7738 6.12 17.0888 6.12H11.0235M4.95808 6.12H7" stroke="#000000" stroke-width="1" stroke-linecap="round"></path> </g></svg>
              <div class="pt-5">
                <h2>{{ $t('tooted') }}</h2>
              </div>
            </v-card>
            <div><v-divider class="content-divider" vertical></v-divider></div>
            <v-divider class="mobile-divider"></v-divider>
            <v-card flat hover draggable="false" class="w-100 py-7" to="/teenused">
              <svg width="200px" height="200px" viewBox="0 0 48.00 48.00" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000000" stroke-width="0"><g id="SVGRepo_bgCarrier" stroke-width="0"><path transform="translate(0, 0), scale(1.5)" d="M16,30.70616443964996C20.026340164154888,30.41386077814937,21.253586400898346,25.346020604170583,23.602745750997702,22.062987418859436C25.689450738779755,19.146743477147687,28.734051620498114,16.711863216190938,28.576983565869146,13.12938557357821C28.38431898097413,8.735006528519607,26.89423749785647,3.4369563300754633,22.724695374323844,2.0360261697855293C18.695437995658494,0.6822304727748953,15.638042735891094,5.468522854169741,11.92286704818028,7.5337461888762185C8.700931680284809,9.324782916077089,4.084703477196768,9.513273019232406,2.959091197316578,13.023497665670444C1.7837113160408624,16.688922698720532,4.589695544373415,20.179523729799097,6.87439132382416,23.277430076604613C9.323740191181246,26.598595839667645,11.884156270441549,31.004965868059998,16,30.70616443964996" fill="#3b71f7" opacity="80%" strokewidth="0"></path></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="day"> <g id="day_2"> <path id="Combined Shape" fill-rule="evenodd" clip-rule="evenodd" d="M25 9V5C25 4.44772 24.5523 4 24 4C23.4477 4 23 4.44772 23 5V9C23 9.55228 23.4477 10 24 10C24.5523 10 25 9.55228 25 9ZM24.0008 34C27.7953 34 31.2116 31.8658 32.9084 28.5468C33.1598 28.0551 33.7622 27.8602 34.254 28.1116C34.7457 28.363 34.9406 28.9655 34.6892 29.4572C32.6537 33.4387 28.5537 36 24.0008 36C17.3732 36 12.0008 30.6269 12.0008 24C12.0008 21.0466 13.0678 18.3423 14.8374 16.2516L9.85729 11.2715C9.46677 10.881 9.46677 10.2478 9.85729 9.85729C10.2478 9.46677 10.881 9.46677 11.2715 9.85729L16.2516 14.8374C18.3423 13.0674 21.0469 12 24.0008 12C30.2903 12 35.4514 16.8414 35.9597 23H43C43.5523 23 44 23.4477 44 24C44 24.5523 43.5523 25 43 25H35.0008H33C32.4477 25 32 24.5523 32 24C32 23.4477 32.4477 23 33 23H33.9514C33.4495 17.9476 29.185 14 24.0008 14C21.5993 14 19.3956 14.8466 17.6717 16.2575L18.7075 17.2933C19.098 17.6838 19.098 18.317 18.7075 18.7075C18.317 19.098 17.6838 19.098 17.2933 18.7075L16.2575 17.6718C14.847 19.3956 14.0008 21.5991 14.0008 24C14.0008 29.5224 18.4778 34 24.0008 34ZM18 24C18 27.3137 20.6863 30 24 30C24.5523 30 25 30.4477 25 31C25 31.5523 24.5523 32 24 32C19.5817 32 16 28.4183 16 24C16 23.4477 16.4477 23 17 23C17.5523 23 18 23.4477 18 24ZM25 39V43C25 43.5523 24.5523 44 24 44C23.4477 44 23 43.5523 23 43V39C23 38.4477 23.4477 38 24 38C24.5523 38 25 38.4477 25 39ZM9 25H5C4.44772 25 4 24.5523 4 24C4 23.4477 4.44772 23 5 23H9C9.55228 23 10 23.4477 10 24C10 24.5523 9.55228 25 9 25ZM33.9003 35.3145L36.7283 38.1425C37.1188 38.533 37.752 38.533 38.1425 38.1425C38.533 37.752 38.533 37.1188 38.1425 36.7283L35.3145 33.9003C34.924 33.5098 34.2908 33.5098 33.9003 33.9003C33.5098 34.2908 33.5098 34.924 33.9003 35.3145ZM12.6855 33.9003L9.85749 36.7283C9.46697 37.1188 9.46697 37.752 9.85749 38.1425C10.248 38.533 10.8812 38.533 11.2717 38.1425L14.0997 35.3145C14.4902 34.924 14.4902 34.2908 14.0997 33.9003C13.7092 33.5098 13.076 33.5098 12.6855 33.9003ZM33.9005 12.6853L36.7285 9.85729C37.119 9.46677 37.7522 9.46677 38.1427 9.85729C38.5332 10.2478 38.5332 10.881 38.1427 11.2715L35.3147 14.0995C34.9242 14.49 34.291 14.49 33.9005 14.0995C33.51 13.709 33.51 13.0758 33.9005 12.6853Z" fill="#000000"></path> </g> </g> </g></svg>
              <div class="pt-5">
                <h2>{{ $t('teenused') }}</h2>
              </div>
            </v-card>
            <div><v-divider class="content-divider" vertical></v-divider></div>
            <v-divider class="mobile-divider"></v-divider>
            <v-card flat hover draggable="false" class="w-100 py-7" to="/uudised">
              <svg width="200px" height="200px" viewBox="-2.4 -2.4 28.80 28.80" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"><path transform="translate(-2.4, -2.4), scale(0.8999999999999999)" d="M16,31.315280972669523C18.410368518103088,31.476490640896678,20.40995891900866,29.598996386801623,22.577345680437595,28.532085154985705C24.797774334426755,27.43906368205529,27.42463865625795,26.88751249896867,28.951533743449772,24.9397982641661C30.496550380771392,22.968968098583105,30.670359656786424,20.303939747737857,30.976220713236394,17.81844242017546C31.282437406397133,15.330055106864473,31.88778256147314,12.638791923426913,30.73954234427076,10.410028928441488C29.601226738660706,8.200529852908799,27.075097274922484,7.140176923224239,24.87707686796009,5.979851592408757C23.013515899978984,4.996085932263777,20.913323604093463,4.840940114212189,18.91619414136153,4.16853527741279C16.72627076587758,3.431219496250975,14.785518680585913,1.4512910836904989,12.50342042121667,1.8138189946506653C10.231686008154915,2.174700533227021,8.981470897360694,4.6152178244579485,7.171175249905575,6.034316974334139C5.2416876788095,7.546851225680506,2.0939613934334087,8.116028354954915,1.4471918130619787,10.480847853017359C0.7833061919598723,12.908249680363575,3.183839215855071,15.087884891872614,4.048712987662283,17.451148971096483C4.721991352244213,19.29087937592803,5.02581169352282,21.203491924279568,5.9944850809062356,22.90630829348997C7.0230119208263035,24.714340146124023,8.276346392896912,26.343798777001503,9.868754478400483,27.682112316422717C11.714201512199907,29.233088334506338,13.594730235673637,31.154412318025372,16,31.315280972669523" opacity="80%" fill="#3b71f7" strokewidth="0"></path></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title></title> <g fill="none" fill-rule="evenodd" id="页面-1" stroke="none" stroke-width="1"> <g id="导航图标" transform="translate(-100.000000, -80.000000)"> <g id="编组" transform="translate(100.000000, 80.000000)"> <rect fill="#FFFFFF" fill-opacity="0.01" fill-rule="nonzero" height="24" id="矩形" width="24" x="0" y="0"></rect> <path d="M2.5,3.5 C2.5,2.671575 3.171575,2 4,2 L16,2 C16.82845,2 17.5,2.671575 17.5,3.5 L17.5,22 L4,22 C3.171575,22 2.5,21.32845 2.5,20.5 L2.5,3.5 Z" id="路径" stroke="#212121" stroke-linejoin="round" stroke-width="1"></path> <path d="M17.5,12 C17.5,11.4477 17.9477,11 18.5,11 L20.5,11 C21.0523,11 21.5,11.4477 21.5,12 L21.5,20.5 C21.5,21.32845 20.82845,22 20,22 L17.5,22 L17.5,12 Z" id="路径" stroke="#212121" stroke-linejoin="round" stroke-width="1"></path> <line id="路径" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" x1="5.5" x2="9.5" y1="6" y2="6"></line> <line id="路径" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" x1="5.5" x2="11.5" y1="9.5" y2="9.5"></line> </g> </g> </g> </g></svg>
              <div class="pt-5">
                <h2>{{ $t('uudised') }}</h2>
              </div>
            </v-card>
          </v-sheet>
        </div>
      </div>
      <feedback-carousel></feedback-carousel>
    </div>
  </div>
</template>

<script>
import {toast} from "vue3-toastify";
import FeedbackCarousel from "@/components/FeedbackCarousel";
import BookRequest from "@/components/BookRequest";

export default {
  components: {BookRequest, FeedbackCarousel},
  data () {
    return {
      items: [
        {
          src: require('@/assets/images/lohnakas_kohvi_webp2.webp'),
          alt: "Koer kohviubadega"
        },
        {
          src: require('@/assets/images/lohnakas_lilled_webp.webp'),
          alt: "Koer lilledega"
        },
        {
          src: require('@/assets/images/eraklient_webp.webp'),
          alt: "Koer pärlitega"
        },
        {
          src: require('@/assets/images/lohnakas_lehed_webp.webp'),
          alt: "Koer lehtedega"
        },
        {
          src: require('@/assets/images/lohnakas_vahukomm_webp.webp'),
          alt: "Koer vahukomm"
        },
      ],
    }
  },
  mounted() {
    if (this.$store.state.showMessage) {
      toast.success(this.$store.state.showMessage);
      this.$store.commit('SET_TOAST_MESSAGE', false);
    }
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = 'src/assets/images/lohnakas_kohvi_webp2.webp';
    document.head.appendChild(link);
  }
}
</script>

<style scoped>
.carousel-height, .v-carousel-item {
  height: calc(300px + 15vw) !important;
  max-height: 650px !important;
}

.welcome {
  font-size: clamp(16px, 5.4vw, 40px);
  font-weight: bold;
}

.carousel-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px 0;
}

.text-content {
  text-decoration: none;
  display: flex;
  justify-content: space-around;
}

.feedback-header {
  display: flex;
  align-items: center;
}

.feedback-icon {
  width: 120px;
  height: 120px;
}

.content-selection {
  background-color: #fafafa;
}

.home-content {
  margin-top: 32px;
}

.content-width {
  margin: auto;
  max-width: 1200px !important;
}

.mobile-divider {
  display: none;
}

@media (max-width: 1200px) {
  .carousel-content {
    display: block;
    padding: 0;
  }
  .home-content {
    margin-top: 0;
  }
}

@media (max-width: 820px) {
  .text-content {
    flex-direction: column;
    margin-left: 0;
    margin-right: 0;
  }
  .carousel-content {
    padding: 0;
  }
  .feedback-header {
    justify-content: center;
  }
  .feedback-icon {
    width: 100px;
    height: 100px;
  }
  .content-divider {
    display: none;
  }
  .mobile-divider {
    display: block;
  }
}
</style>